import {
  RESET_PASSWORD,
  RESET_PASSWORD_SUCCESSFUL,
  RESET_PASSWORD_FAILED
} from "./actionTypes";

const initialState = {
  message: null,
  loading: false,
  user: null,
  success: false,
  error: false
};

const ResetPassword = (state = initialState, action) => {
  switch (action.type) {
    case RESET_PASSWORD:
      state = {
        ...state,
        loading: true,
        message: null,
      };
      break;
    case RESET_PASSWORD_SUCCESSFUL:
      state = {
        ...state,
        loading: false,
        user: action.payload.data,
        success: true,
        message: null,

      };
      break;
    case RESET_PASSWORD_FAILED:
      state = {
        ...state,
        user: null,
        loading: false,
        message: action.payload,
        error: true
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default ResetPassword;
